import { combineReducers } from 'redux';

import { createResourcesReducer } from 'medialoopster/rest';

import { ProductionContentRootState } from './types';

export default combineReducers<ProductionContentRootState>({
  objects: createResourcesReducer('productioncontent'),
});
